/* Pretend the parent element isn't even here; we really just want the dialog */
:host {
  all: initial;
  --zapier-brand: #90a1ed;
  --zapier-brand-120: #f0f1fa;
  --zapier-text: #fffdf9;
  --zapier-text-80: #e8e7e4;
  --zapier-text-60: #d7d5d2;
  --zapier-bg-5: #2d2e2e;
  --zapier-bg-5b: #2d2e2e;
  --zapier-bg-0: #2d2e2e;
  --zapier-icon-color: rgb(255 255 255 / 70%);
  --zapier-icon-border-color: rgb(0 0 0 / 20%);
  --zapier-border-color: rgb(255 255 255 / 40%);
  --zapier-input-border-color: rgb(255 255 255 / 40%);
  --zapier-service-icon-border-color: rgb(0 0 0 / 20%);
  --zapier-button-text: #2d2e2e;
  --zapier-button-bg: #fffdf9;
  --zapier-button-bg-hover: #fff;
  --zapier-modal-background-color: #2d2e2e;
  --zapier-modal-border-color: rgb(0 0 0 / 80%);
  --gap: 20px;
  color: var(--zapier-text);
  font-family: var(--zapier-font-family);
  display: contents;
}

dialog::backdrop {
  background: rgb(0 0 0 / 40%);
}

dialog {
  padding: 0;
  box-sizing: border-box;
  background: transparent;
  background-clip: padding-box;
  overflow: visible;
  border: 0;
  max-width: calc(100vw - calc(2 * var(--gap)));
  max-height: calc(100vh - calc(2 * var(--gap)));
  color-scheme: light dark;
}

:host([data-size="large"]) dialog {
  max-width: 1440px;
  width: calc(100vw - calc(2 * var(--gap)));
  height: calc(100vh - calc(2 * var(--gap)));
}
